import { Leaf } from "lucide-react";
import type { Product } from "@/types";
import { Container } from "@/components/atoms";

export function WhyFormula({ product }: { product: Product }) {
  if (!product.ingredients.length) return null;
  return (
    <section className="bg-medical-grey py-12">
      <Container>
        <h2 className="mb-8 text-center font-condensed text-2xl font-bold text-night-blue">
          Why this formula works
        </h2>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {product.ingredients.map((ing) => (
            <div
              key={ing.name}
              className="flex flex-col gap-2 rounded-card bg-white p-5"
            >
              <Leaf size={22} className="text-leaf-green-ink" />
              <h3 className="font-condensed font-bold text-night-blue">
                {ing.name}
              </h3>
              <p className="text-sm text-night-blue/70">{ing.detail}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
